import React from "react";
import centerSeala from "../../../assets/76/centerSeala.webp";
import centerSealb from "../../../assets/76/centerSealb.webp";
import centerSealCover from "../../../assets/76/76Hero.jpg";

import w771 from "../../../assets/w77/w771.webp";
import w772 from "../../../assets/w77/w772.webp";
import w773 from "../../../assets/w77/w773.webp";
import w774 from "../../../assets/w77/w774.webp";
import w775 from "../../../assets/w77/w775.webp";
import w776 from "../../../assets/w77/w776.webp";
import w777 from "../../../assets/w77/w777.webp";
import w778 from "../../../assets/w77/w778.webp";
import w779 from "../../../assets/w77/w779.webp";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";

const Center76 = () => {
  return (
    <div>
      <div className="flex flex-col justify-center pt-12 pb-12 md:pt-32 bg-white">
        <div className="md:container relative flex flex-col md:flex-row md:space-x-5 space-y-3 md:space-y-0 p-0 max-w-sm md:max-w-full mx-auto">
          <div className="w-full md:w-2/4 pt-2 md:p-6 flex flex-col space-y-2 md:pb-10">
            <h3 className="text-4xl md:text-6xl md:text-center leading-8 font-suranna font-medium tracking-wider md:p-6">
              KOEMMERLING 76
            </h3>
            <h3 className="font-montserrat font-normal text-black md:text-center text- pb-3 text-md md:text-lg tracking-wide">
              Kömmerling 76 center seal standard
            </h3>

            <div className="md:hidden max-w-xl pb-6">
              <img
                src={centerSealCover}
                alt="Center Seal"
                className="object-cover w-full h-full"
              />
            </div>

            <div className="md:p-12 md:pr-32 md:pl-32">
              <p className="text-left leading-8 font-montserrat font-medium md:text-base tracking-narrow pb-5">
                The Kömmerling 76 centre seal system offers all the benefits
                modern windows can give you. This centre seal system with six
                chambers and 76 mm construction depth offers a fascinating
                combination of modern design and perfect profile proportions.
                Whether function, structural properties, insulation values,
                environmental protection, or preservation of value, it fulfills
                the requirements of both today, and above all tomorrow. The
                Kömmerling 76 centre seal system is such an innovative design
                that it can take modern triple glazing or special functional
                glazing with panes up to 50 mm thick. Thanks to intelligent
                fastening technology, the professional installation is fast,
                clean, and effortless.
              </p>
              <p className="text-left leading-8 font-montserrat font-semibold text-xl tracking-narrow md:pb-2">
                Specifications
              </p>
              <div className="md:block md:pb-12">
                <div className="grid md:grid-cols-3 max-w-7xl md:text-base text-left pt-6">
                  <span className="pr-10 font-semibold">
                    WINDOW TYPE
                    <span className="pr-10 block font-normal pb-4">Hinged</span>
                  </span>
                  <span className="pr-10 font-semibold">
                    THERMAL INSULATION
                    <span className="pr-10 block font-normal pb-4">Yes</span>
                  </span>
                  <span className="pr-10 font-semibold">
                    FRAME DEPTH
                    <span className="pr-10 block font-normal pb-4">76 mm</span>
                  </span>
                  <span className="pr-10 font-semibold">
                    GLAZING TYPE
                    <span className="pr-10 block font-normal pb-4">
                      Double - Triple
                    </span>
                  </span>
                  <span className="pr-10 font-semibold">
                    MAXIMUM GLAZING THICKNESS
                    <span className="pr-10 block font-normal pb-4">50 mm</span>
                  </span>
                  <span className="pr-10 font-semibold">
                    UF
                    <span className="pr-10 block font-normal pb-4">
                      1.0 W(m²K)
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="hidden md:block md:w-2/4 pr-32 h-full">
            <img
              src={centerSealCover}
              alt="Center Seal"
              className="object-fit w-full h-full"
            />
          </div>
        </div>
      </div>
      <div className="flex flex-col justify-center pb-12 bg-white">
        <div className="md:block w-full md:w-4/4 pt-2 flex flex-col space-y-2 mx-auto pb-12">
          <div className="md:container md:grid md:grid-cols-2 gap-2 mx-auto">
            <div className="w-full pb-4 md:pb-0">
              <img src={centerSeala} alt="Center Seal Render 1" />
            </div>
            <div className="w-full pb-4 md:pb-0">
              <img src={centerSealb} alt="Center Seal Render 2" />
            </div>
          </div>
        </div>

        <div className="md:container relative flex flex-col md:flex-row md:space-x-5 space-y-3 md:space-y-0 p-0 max-w-sm md:max-w-full mx-auto">
          <div className="w-full md:w-4/4 md:pt-2 md:p-6 flex flex-col space-y-2 md:pb-10">
            <h3 className="md:pl-32 font-montserrat font-semibold text-left tracking-widest text-black text-base underline leading-6 underline-offset-8">
              TYPOLOGIES
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-6 md:pl-32 max-w-7xl text-sm md:text-base font-montserrat text-left pt-6 ">
              <span className="pr-10 pb-4 ">
                <img
                  src={w771}
                  alt="Center Seal Typology 1"
                  className="object-contain h-24 mt-auto mx-auto"
                />
                Typology 1
              </span>
              <span className="pr-10 pb-4  ">
                <img
                  src={w772}
                  alt="Center Seal Typology 2"
                  className="object-contain h-24  mx-auto"
                />
                Typology 2
              </span>
              <span className="pr-10 pb-4  ">
                <img
                  src={w773}
                  alt="Center Seal Typology 3"
                  className="object-contain h-24  mx-auto"
                />
                Typology 3
              </span>
              <span className="pr-10 pb-4">
                <img
                  src={w774}
                  alt="Center Seal Typology 4"
                  className="object-contain h-24  mx-auto"
                />
                Typology 4
              </span>
              <span className="pr-10 pb-4">
                <img
                  src={w775}
                  alt="Center Seal Typology 5"
                  className="object-contain h-24  mx-auto"
                />
                Typology 5
              </span>
              <span className="pr-10 pb-4">
                <img
                  src={w776}
                  alt="Center Seal Typology 6"
                  className="object-contain h-24  mx-auto"
                />
                Typology 6
              </span>
              <span className="pr-10 pb-4">
                <img
                  src={w777}
                  alt="Center Seal Typology 6"
                  className="object-contain h-24  mx-auto"
                />
                Typology 7
              </span>
              <span className="pr-10 pb-4">
                <img
                  src={w778}
                  alt="Center Seal Typology 6"
                  className="object-contain h-24  mx-auto"
                />
                Typology 8
              </span>
              <span className="pr-10 pb-4">
                <img
                  src={w779}
                  alt="Center Seal Typology 6"
                  className="object-contain h-24  mx-auto"
                />
                Typology 9
              </span>
            </div>

          
          </div>
        </div>
      </div>
      

      <h3 className="md:pl-32 md:pt-12 font-montserrat font-semibold text-left tracking-widest text-black text-base underline leading-6 underline-offset-8">
        RELATED FILES
      </h3>
      
      <div className="flex flex-wrap mt-4 p-3 md:pl-32 md:pt-4 items-center">
        <div>
          <a
            href="https://www.koemmerling.com/cms16/files/Koemmerling-76-centre-seal-standard-brochure-2421130141-0623-web.pdf?download=1"
            className="font-bold"
          >
            <FontAwesomeIcon
              className="pr-2 fa-3x"
              icon={faFilePdf}
              style={{ color: "#E5B50B" }}
            />{" "}
            Kömmerling 76 center seal standard
          </a>
        </div>
      </div>
    </div>
  );
};

export default Center76;
